// extracted by mini-css-extract-plugin
export default {"box":"Tooltip_box__NGlHW","icon":"Tooltip_icon__0aLOR","tooltip":"Tooltip_tooltip__sTilD"};